import { useAuth } from 'react-oidc-context';
import type { Tenant } from '../../api/platformTenants';
import { useUpdateTenant, useTenantSummary } from '../../api/platformTenants';
import { TenantOverviewForm } from '../../components/tenants/TenantOverviewForm';
import { TenantKpiPanel } from '../../components/tenants/TenantKpiPanel';

interface Props { tenant: Tenant; disabled: boolean; }

export default function TenantDetailOverview({ tenant, disabled }: Props) {
  const auth = useAuth();
  const token = auth.user?.access_token ?? null;

  const updateMut = useUpdateTenant(tenant.id, token);
  const { data: summary } = useTenantSummary(tenant.id, token);

  return (
    <div style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)', gap: 24 }}>
      <div>
        <h3>Metadata</h3>
        <p><strong>code</strong>: <code>{tenant.code}</code></p>
        <h3>Form</h3>
        <TenantOverviewForm
          initialName={tenant.name}
          initialNote={tenant.note ?? ''}
          disabled={disabled}
          onSubmit={(patch) => updateMut.mutate(patch)}
        />
      </div>
      <div>
        <h3>KPI summary</h3>
        {summary && <TenantKpiPanel summary={summary} />}
      </div>
    </div>
  );
}
